import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import { getImageProps } from 'app/utilities/ImageProps';
import { prepareUrl } from '../../../utilities/StringHelpers/StringHelpers.js';
import { Swiper, SwiperSlide } from 'swiper/react';



function LobbyCellphone(props) {
  const { iContent, context } = props; //from EPI
    // All data from EPI
    //Desktop
    const priTitleDes = iContent?.priTitleDes?.value;
    const secBannerDes = iContent?.secBannerDes?.value;
    const buttonTextDes =  iContent?.buttonTextDes?.value;
    const buttonColorDes = iContent?.buttonColorDes?.value;
    const backgroundImageDes = getImageProps(iContent?.backgroundImage1920Des,context);
    const linkBtnDes = iContent?.linkBtnDes?.value;

    //Mobile
    const priTitleMobile = iContent?.priTitleMobile?.value;
    const secBannerMobile = iContent?.secBannerMobile?.value;
    const buttonTextMobile =  iContent?.buttonTextMobile?.value;
    const buttonColorMobile = iContent?.buttonColorMobile?.value;
    const backgroundImageMobile = getImageProps(iContent?.backgroundImageMobile,context);
    const lingBtnMobile = iContent?.linkBtnMobile?.value;

    const cards = iContent?.items?.expandedValue?.map((item)=> {
      const linkButtonCard = item?.linkButtonCard?.value;
      const buttonText = item?.buttonText?.value;
      const imageSquare = getImageProps(item?.imageSquare, context);
      const buttonColorSquare = item?.buttonColorSquare?.value;
      return {
        linkButtonCard,
        buttonText,
        imageSquare,
        buttonColorSquare
      };
    });

    const clickBtnDes = () => {
      if(linkBtnDes !== null) {
        prepareUrl(linkBtnDes, props.context);
      };
    };

    const clickBtnMobile = ()=> {
      if(lingBtnMobile !== null) {
        prepareUrl(lingBtnMobile, props.context);
      };
    };

    const clickCard = (item) => {
      if(item.linkButtonCard !== null) {
        prepareUrl(item.linkButtonCard, props.context);
      };
    };

  return (
    <div
      id={props.iContent.idToScroll?.value}
      className ={
      `wrapper-block-des-mobile
      ${buttonTextDes.length >=1 ? '' : 'wrapper-block-des-small'}
      ${buttonTextMobile.length >=1 ? '': 'wrapper-block-mobile-small'}`}
    >
      <div className={`banner-desktop ${buttonTextDes.length >=1 ? '' : 'banner-desktop-small'}`} style={{backgroundImage: `url("${backgroundImageDes.src}")`}}>
        <div className='wrapper-titles'>
          {priTitleDes && priTitleDes.length > 0 && <p className='pri-title' dangerouslySetInnerHTML={{ __html: priTitleDes }}></p>}
          {secBannerDes && secBannerDes.length > 0 && <p className='sec-title' dangerouslySetInnerHTML={{ __html: secBannerDes }}></p>}
          {buttonTextDes && buttonTextDes.length > 0 && <button style={{backgroundColor: buttonColorDes}} onClick={() => clickBtnDes()}>{buttonTextDes}</button>}
        </div>
        <div className='container-cards'>
          <div className='wrapper-cards'>
            {cards && cards.length > 1 &&
              <Swiper
                slidesPerView={'auto'}
                navigation={false}
                enabled={cards.length >= 3} //Will trigger a swiper only if the length of the array is greater than 2
                spaceBetween={21}
                breakpoints={{
                  //when window width is >= 100px
                  100: {
                      allowTouchMove: true, //swiper at mobile
                  },
                  // when window width is >= 835px
                  1190: {
                      allowTouchMove: false //no swiper at desktop
                  }
              }}
              >
                {cards.map((item,i)=>
                <SwiperSlide
                  key={i}
                  onClick={()=>clickCard(item)}
                >
                  <div className='wrapper-img' style={{background: item?.buttonColorSquare}}>
                    {item.imageSquare.src && <Image src={item.imageSquare.src} alt="card-image" />}
                  </div>
                  {item.buttonText && <p>{item.buttonText}</p>}
                </SwiperSlide>
                )}
              </Swiper>
            }
          </div>
        </div>
      </div>
      <div className={`banner-mobile ${buttonTextMobile.length >=1 ? '': 'banner-mobile-small'}`} style={{backgroundImage: `url("${backgroundImageMobile.src}")` }}>
        <div className={`wrapper-titles`}>
          {priTitleMobile && priTitleMobile.length > 0 && <p className='pri-title' dangerouslySetInnerHTML={{ __html: priTitleMobile }}></p>}
          {secBannerMobile && secBannerMobile.length > 0 && <p className='sec-title' dangerouslySetInnerHTML={{ __html: secBannerMobile }}></p>}
          {buttonTextMobile && buttonTextMobile.length > 0 && <button style={{backgroundColor: buttonColorMobile}} onClick={(e) => clickBtnMobile(e)}>{buttonTextMobile}</button>}
        </div>
        <div className='container-cards'>
          <div className='wrapper-cards'>
              {cards && cards.length > 1 &&
              <Swiper
                slidesPerView={'auto'}
                navigation={false}
                enabled={cards.length >= 3} //Will trigger a swiper only if the length of the array is greater than 2
                spaceBetween={12}
              >
                {cards.map((item,i)=>
                <SwiperSlide
                  key={i}
                >
                  <div className='wrapper-img' onClick={ ()=>clickCard(item) }  style={{background: item?.buttonColorSquare}}>
                    {item.imageSquare.src && <Image src={item.imageSquare.src} alt="card-image" />}
                  </div>
                  {item.buttonText && <p>{item.buttonText}</p>}
                </SwiperSlide>
                )}
              </Swiper>
              }
          </div>
        </div>
      </div>
    </div>
  )
}

export default LobbyCellphone
